
import { VueSlickPopover, VueSlickPopoverContent } from 'vue-slick-popover'
import 'vue-slick-popover/dist/vue-slick-popover.css'
import { controls } from '~/mixins/popover'

export default {
  components: {
    VueSlickPopover,
    VueSlickPopoverContent,
  },
  mixins: [controls],
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },

  mounted() {
    this.$nextTick(() => {
      if (this.$matchMedia('sm')) {
        this.init()
      }
    })
  },
  methods: {
    init() {
      this.$gsap.set('.stat-pill', {
        opacity: 0,
        scale: 0.8,
      })

      const tl = this.$gsap.timeline()
      tl.from('path', {
        drawSVG: 0,
        duration: 1.2,
      })

      tl.to('.stat-pill', {
        opacity: 1,
        scale: 1,
        stagger: 0.1,
        onComplete: () => {
          const tweenProperty = (target, prop, min, max) => {
            const randomDur = this.$gsap.utils.random(3, 6, 0.2, true)
            const randomDelay = this.$gsap.utils.random(0.6, 2, 0.2, true)

            this.$gsap.to(target, {
              [prop]: this.$gsap.utils.random(min, max),
              duration: randomDur(),
              delay: randomDelay(),
              ease: 'none',
              onComplete: tweenProperty,
              onCompleteParams: [target, prop, min, max],
            })
          }

          // Animate the properties individually
          this.$gsap.utils.toArray('.stat-pill').forEach((star) => {
            // tweenProperty(star, "scale", 0.5, 4);
            tweenProperty(star, 'x', -12, 12)
            // tweenProperty(star, 'y', -12, 12)
          })
        },
      })
    },
  },
}
